export const formErrors = Object.freeze({
  notAllowedNumbers: 'Números não são permitidos',
  phoneNumberNotAllowed: 'Insira o número de corretamente',
});
